import { useDispatch } from 'react-redux';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer/utils';
import { TOAST_ACTIONS } from '../constants';
import { useEditCriteria } from './useEditCriteria';

export const useToggleAnonCriteriaActive = (criteria: AnonUserCriteria) => {
  const dispatch = useDispatch();
  const { editCriteria } = useEditCriteria();

  const toggleActiveState = (active: boolean, onCompleted?: () => void) => {
    editCriteria({
      variables: {
        id: criteria.id,
        criteria: {
          ...criteria.fields,
          isLive: active,
        },
      },
      onCompleted: (data) => {
        dispatch(
          addPositiveToast(
            <>
              <strong>{criteria.fields.name}</strong> turned{' '}
              {data.updateAnonUserCriteria.payload.fields.isLive ? 'on' : 'off'} successfully.
            </>,
          ),
        );
        onCompleted?.();
      },
      onError: (e, options) => {
        dispatch(
          addNegativeToastWithErrorId(
            <>
              Error turning {options?.variables?.criteria.isLive ? 'on' : 'off'}{' '}
              <strong>{criteria.fields.name}</strong>. Please try again.
            </>,
            options?.variables?.criteria.isLive
              ? TOAST_ACTIONS.activateCriteria
              : TOAST_ACTIONS.deactivateCriteria,
            e,
          ),
        );
      },
    });
  };

  return {
    toggleCriteriaActive: toggleActiveState,
  };
};
